'use client'
import { Button } from '@/components/ui/button';
import Image from 'next/image';
import Link from 'next/link';

export default function Error() {
  return (
    <div className="min-h-screen bg-[#fdf7f0] flex items-center">
      <div className="max-w-3xl mx-auto flex flex-col justify-center items-center text-center px-4">
        <h1 className="text-5xl font-bold mb-4">
          500
        </h1>

        <div className="my-8">
          <Image
            src="/images/robot-500.png"
            alt="Error del Servidor Robot"
            width={350}
            height={350}
            priority
          />
        </div>

        <h2 className="text-2xl mb-4">
          ¡Ups! Algo salió mal
        </h2>

        <p className="text-base text-muted-foreground mb-8">
          Nuestro servidor encontró un error. Por favor, inténtelo de nuevo más tarde o regrese a la página de inicio.
        </p>

        <Button asChild>
          <Link href="/">Ir a Inicio</Link>
        </Button>
      </div>
    </div>
  );
}